<script setup lang="ts">
import { computed } from 'vue';
import {
  DropdownMenuTrigger,
  type DropdownMenuTriggerProps,
  useForwardProps
} from 'radix-vue';

import { createDelegatedProps } from '@/lib/helpers';

const props = withDefaults(defineProps<
  DropdownMenuTriggerProps & {
    testId?: string;
  }
>(), {
  testId: 'dropdown-menu'
});

const delegatedProps = computed(() =>
  createDelegatedProps<typeof props>(props)
);

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <DropdownMenuTrigger
    class="outline-none"
    v-bind="forwardedProps"
    :data-testid="`${props.testId}-trigger`"
  >
    <slot />
  </DropdownMenuTrigger>
</template>
